import React, { useState, useCallback, useEffect } from "react";
import useAdminDataStore, { selectCurrentGroupData } from "../../../../store/adminData/adminData";
import ScreenHeader from "../../../../CommonComponents/ScreenHeader";
import TabNav from "../../../../CommonComponents/TabNav/TabNav";
import FlaggedMembers from "./FlaggedMembers/FlaggedMembers";
import RestrictedDMs from "./RestrictedDms/RestrictedDms";

const Safety = () => {
  const groupData = useAdminDataStore(selectCurrentGroupData);

  const getStoredTab = useCallback((groupId) => {
    if (!groupId) return "flagged-members";
    const stored = localStorage.getItem(`safetyTab_${groupId}`);
    return stored === "restricted-dms" ? "restricted-dms" : "flagged-members";
  }, []);

  const [tab, setTab] = useState(() => getStoredTab(groupData?.id));

  const handleTabChange = useCallback(
    (key) => {
      setTab(key);
      if (groupData?.id) {
        localStorage.setItem(`safetyTab_${groupData.id}`, key);
      }
    },
    [groupData?.id],
  );

  useEffect(() => {
    if (groupData?.id) {
      const storedTab = getStoredTab(groupData.id);
      setTab(storedTab);
    }
  }, [groupData?.id, getStoredTab]);

  const tabItems = [
    {
      key: "flagged-members",
      label: "Blocked Members",
    },
    {
      key: "restricted-dms",
      label: "Restricted DMs",
    },
  ];

  return (
    <div style={{ width: "100%", height: "100%", padding: "12px" }}>
      <ScreenHeader title="Safety" />

      <div style={{ paddingTop: "2px" }}>
        <TabNav
          items={tabItems}
          activeKey={tab}
          handleTabChange={handleTabChange}
        />
      </div>

      <div style={{ marginTop: "var(--screen-general-margin)" }}>
        {tab === "flagged-members" && <FlaggedMembers />}
        {tab === "restricted-dms" && <RestrictedDMs />}
      </div>
    </div>
  );
};

export default Safety;
